var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 0C24.6272 0 0 24.6272 0 55C0 85.3728 24.6272 110 55 110C85.3728 110 110 85.3728 110 55C110 24.6272 85.3728 0 55 0ZM55 100.67C29.7835 100.67 9.33036 80.2165 9.33036 55C9.33036 29.7835 29.7835 9.33036 55 9.33036C80.2165 9.33036 100.67 29.7835 100.67 55C100.67 80.2165 80.2165 100.67 55 100.67Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1052 76.6071C49.1052 78.17 49.7261 79.6689 50.8312 80.774C51.9363 81.8791 53.4352 82.5 54.9981 82.5C56.561 82.5 58.0598 81.8791 59.165 80.774C60.2701 79.6689 60.8909 78.17 60.8909 76.6071C60.8909 75.0443 60.2701 73.5454 59.165 72.4403C58.0598 71.3351 56.561 70.7143 54.9981 70.7143C53.4352 70.7143 51.9363 71.3351 50.8312 72.4403C49.7261 73.5454 49.1052 75.0443 49.1052 76.6071ZM52.0517 62.8571H57.9445C58.4847 62.8571 58.9267 62.4152 58.9267 61.875V28.4821C58.9267 27.942 58.4847 27.5 57.9445 27.5H52.0517C51.5115 27.5 51.0695 27.942 51.0695 28.4821V61.875C51.0695 62.4152 51.5115 62.8571 52.0517 62.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWarningIcon);
export default __webpack_public_path__ + "static/media/modalWarningIcon.ec14c0f01ced1ddc8679e08a092a51b5.svg";
export { ForwardRef as ReactComponent };